import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PageHeader } from "@/components/Common";
import LedgerTab from "@/pages/po/LedgerTab";
import OpenOrdersTab from "@/pages/po/OpenOrdersTab";
import PendingTab from "@/pages/po/PendingTab";
import LogTab from "@/pages/po/LogTab";

const TABS = [["ledger", "Product ledger", LedgerTab], ["open", "Open orders", OpenOrdersTab], ["pending", "Pending items", PendingTab], ["log", "Receipt log", LogTab]];

export default function PoReceipts() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "ledger";
  return (
    <div data-testid="po-receipts-page">
      <PageHeader title="PO Receipts" subtitle="Every delivery is a GRN linked to its Purchase / Manufacturing Order. Received, pending and status come from GRNs." />
      <Tabs value={tab} onValueChange={(t) => setSp({ tab: t })}>
        <TabsList className="mb-4 flex-wrap h-auto">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`po-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k}>{tab === k && <C />}</TabsContent>)}
      </Tabs>
    </div>
  );
}
